/*global TTLicenseStatusEnum */
/*eslint no-undef: "error"*/

import React, { Component } from 'react';
import { Link }             from 'react-router-dom';
import cx                   from 'classnames';
import moment               from 'moment';

import { Column, Table, WindowScroller }  from 'react-virtualized';

import { Page, QuestionBox }                 from 'moovila-common';
import Masthead                 from '../Masthead';
import AddEditLicenseAssignment from './AddEditLicenseAssignment';

let baseURI;

class LicenseAssignment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showExpired: false,
    }

    this.toggleExpired    = this.toggleExpired.bind(this);
    this.getMode          = this.getMode.bind(this);
  }

  componentWillMount() {
    baseURI = this.props.location.pathname;
  }

  toggleExpired() {
    this.setState({
      showExpired: !this.state.showExpired,
    });
  }

  getMode(context, method, submethod) {
    if (submethod === 'add') {
      return 'ADD';
    }
    if (submethod === 'edit') {
      return 'EDIT';
    }
    if (submethod === 'delete') {
      return 'DELETE';
    }
  }

  render() {
    let modal = null;
    const { context, method, submethod } = this.props;
    const assignments = this.state.showExpired ? this.props.assignments : this.props.assignments.filter(a => !a.endDate || moment(a.endDate).startOf('day').add(1, 'days').isAfter(moment()));

    const enterpriseName = this.props.enterprises.length ? this.props.enterprises.filter(e => e.enterpriseGUID === this.props.enterpriseGUID)[0].enterpriseName : '';
    const user = this.props.users.length && this.props.primaryGUID ? this.props.users.filter(u => u.userGUID === this.props.primaryGUID)[0] : null;
    const userName = user ? user.userDisplayName : '';
    const assignmentContext = this.props.type === 'enterprise' ? enterpriseName : userName;

    const idKey = this.props.context === 'users' ? 'userLicenseID' : 'enterpriseLicenseID';
    const isUserPage = this.props.context === 'users';
    const mode = this.getMode(context, method, submethod);
    if (mode === 'ADD' || mode === 'EDIT') {
      modal = (
        <AddEditLicenseAssignment
          mode={mode}
          context={context}
          backTo={baseURI}
          licenses={this.props.licenses}
          assignments={this.props.assignments}
          primaryGUID={this.props.primaryGUID}
          licenseGUID={this.props.submethod === 'add' ? null : this.props.secondaryGUID}
          licenseID={this.props.submethod === 'add' ? null : this.props.licenseID}
          showMessageBox={this.props.showMessageBox}
          updateLicenseAssignment={this.props.updateLicenseAssignment}
          updateUserLicenseAssignment={this.props.updateUserLicenseAssignment}
          setQuestion={this.props.setQuestion}
          history={this.props.history}
        />
      );
    } else if (mode === 'DELETE') {
      const key = context === 'users' ? 'userLicenseID' : 'enterpriseLicenseID';
      const guid = context === 'users' ? 'userGUID' : 'enterpriseGUID';
      const licenseName = this.props.licenses.filter(l => l.licenseGUID === this.props.secondaryGUID)[0].name;
      const assignment = this.props.assignments.filter(a => a.licenseGUID === this.props.secondaryGUID && String(a[key]) === this.props.licenseID)[0]
      const period =
        assignment.startDate || assignment.endDate ?
          assignment.startDate && assignment.endDate ?
            ` for ${moment(assignment.startDate).format('M/D/YYYY')} until ${moment(assignment.endDate).format('M/D/YYYY')}`
          :
            assignment.startDate ?
              ` beginning ${moment(assignment.startDate).format('M/D/YYYY')}`
            :
              ` ending ${moment(assignment.endDate).format('M/D/YYYY')}`
        : '';
      const remainingAssignments = this.props.assignments.filter(a => a.licenseGUID != this.props.secondaryGUID);
      const assignmentsBody = {
        enterpriseGUID: this.props.primaryGUID,
        userGUID: this.props.primaryGUID,
        licenses: remainingAssignments,
      } 
      modal = (
        <QuestionBox
          size='md'
          title='Delete License Assignment'
          yesText='Yes, delete'
          yesCallback={() => isUserPage ? this.props.deleteUserLicenseAssignment(assignmentsBody) : this.props.deleteLicenseAssignment(assignmentsBody)}
          yesTo={baseURI}
          noTo={baseURI}
        >
          <div>
            <section className='section'>
              <div className='row'>
                <div className='col-xs-12'>
                  { `Are you sure you want to delete the assignment of ${licenseName}${period}?`}
                </div>
              </div>
            </section>
          </div>
        </QuestionBox>
      );
    }

    const backToSuffix = this.props.type === 'user' ? `users/${this.props.enterpriseGUID}` : `enterprises/${this.props.enterpriseGUID}`;
    const backToTextSuffix = this.props.type === 'user' ? 'users' : '';
    return (
      <div>
        <Masthead title={`License Assignment (${assignmentContext})`} icon='fa-id-card' backTo={`/admin/enterprise-maintenance/${backToSuffix}`} backText={`Back to enterprise ${backToTextSuffix}`} />
        <Page>
          <section className='section'>
            { assignments.length ? (
              <WindowScroller>
                {({ height, isScrolling, scrollTop }) => (
                <Table
                  className='table-bordered'
                  autoHeight
                  height={height}
                  headerHeight={44}
                  isScrolling={isScrolling}
                  scrollTop={scrollTop}
                  rowCount={assignments.length}
                  rowGetter={({index}) => assignments[index]}
                  rowHeight={52}
                  width={992}
                >
                  <Column
                    width={121}
                    label='Status'
                    dataKey='statusCode'
                    cellRenderer={({cellData, rowData}) => {
                      const statusTextClass = cx({
                        'status-badge SubscriberMaintenance_btnEditStatus': true,
                        'text-default':             cellData === TTLicenseStatusEnum.LS_REQUESTED,
                        'text-warning':             cellData === TTLicenseStatusEnum.LS_ON_HOLD,
                        'text-success':             cellData === TTLicenseStatusEnum.LS_APPROVED,
                        'text-danger':              cellData === TTLicenseStatusEnum.LS_REJECTED,
                        'text-fade':                rowData.endDate && moment(rowData.endDate).startOf('day').add(1, 'days').isBefore(moment()),
                      });
                      const statusIconClass = cx({
                        'fa status-icon': true,
                        'fa-clock-o':               cellData === TTLicenseStatusEnum.LS_REQUESTED,
                        'fa-exclamation-triangle':  cellData === TTLicenseStatusEnum.LS_ON_HOLD,
                        'fa-thumbs-up':             cellData === TTLicenseStatusEnum.LS_APPROVED,
                        'fa-thumbs-down':           cellData === TTLicenseStatusEnum.LS_REJECTED,
                      });
                      const statusText = cx({
                        'Pending':                  cellData === TTLicenseStatusEnum.LS_REQUESTED,
                        'Suspended':                cellData === TTLicenseStatusEnum.LS_ON_HOLD,
                        'Active':                   cellData === TTLicenseStatusEnum.LS_APPROVED,
                        'Rejected':                 cellData === TTLicenseStatusEnum.LS_REJECTED,
                      });
                      return (
                        cellData === null ? '' :
                        <div className={statusTextClass}>
                          <i className={statusIconClass}></i>
                          <span className='status-type'>
                            {statusText}
                          </span>
                        </div>
                      );
                    }}
                  />
                  <Column
                    width={190}
                    label='Name'
                    dataKey='name'
                    cellRenderer={({cellData, rowData}) => {
                      const textClass = cx({
                        'ellipsis': true,
                        'text-fade': rowData.endDate && moment(rowData.endDate).startOf('day').add(1, 'days').isBefore(moment())
                      })
                      return cellData === null ? '' :
                        <span className={textClass}>{cellData}</span>
                    }}
                  />
                  <Column
                    width={80}
                    label='Start'
                    className='text-center'
                    dataKey='startDate'
                    cellRenderer={({cellData, rowData}) => {
                      return cellData === null ? '' :
                        <span className={rowData.endDate && moment(rowData.endDate).startOf('day').add(1, 'days').isBefore(moment()) ? 'text-fade' : ''}>
                          {cellData ? moment(cellData).format('M/D/YY') : ''}
                        </span>
                    }}
                  />
                  <Column
                    width={80}
                    label='End'
                    className='text-center'
                    dataKey='endDate'
                    cellRenderer={({cellData, rowData}) => {
                      return cellData === null ? '' :
                        <span className={rowData.endDate && moment(rowData.endDate).startOf('day').add(1, 'days').isBefore(moment()) ? 'text-fade' : ''}>
                          {cellData ? moment(cellData).format('M/D/YY') : ''}
                        </span>
                    }}
                  />
                  <Column
                    width={400}
                    label=''
                    dataKey='licenseGUID'
                    cellRenderer={() => null}
                  />
                  <Column
                    width={50}
                    label='Edit'
                    dataKey='licenseGUID'
                    cellRenderer={({cellData, rowData}) => {
                      return cellData === null ? '' : (
                        <Link to={`${baseURI}/edit/${cellData}/${rowData[idKey]}`} className='btn btn-default btn-block btn-md EnterpriseMaintenance__btn-icon'>
                          <i className='fa fa-pencil-square-o fa-2x'></i>
                        </Link>
                      );
                    }}
                  />
                  <Column
                    width={50}
                    label='Delete'
                    dataKey='licenseGUID'
                    cellRenderer={({cellData, rowData}) => {
                      return cellData === null ? '' : (
                        <Link to={`${baseURI}/delete/${cellData}/${rowData[idKey]}`} className='btn btn-default btn-block btn-md EnterpriseMaintenance__btn-icon'>
                          <i className='fa fa-trash' style={{fontSize: '1.5em'}}></i>
                        </Link>
                      );
                    }}
                  />
                </Table>
              )}
              </WindowScroller>
            ) : <h2>{`There are currently no ${this.state.showExpired ? '' : 'active'} license assignments.`}</h2> }

            <div className='table-footer'>
              <div className='row' style={{marginLeft: 0}}>
                <div className='col-xs-10'>
                  <Link to={`${baseURI}/add`} className='btn btn-primary btn-xl btn-margin-fix' id='UserMaintenance_btnAddUser'>
                      <i className='fa fa-plus-circle icon' aria-hidden='true'></i>
                      Add assignment
                  </Link>
                </div>
                { this.props.assignments.length ? (<div className='col-xs-2'>
                  <input
                    checked={this.state.showExpired}
                    onChange={this.toggleExpired}
                    className='table-footer__checkbox'
                    name='RoleMaintenance_chkFilter'
                    id='RoleMaintenance_chkFilter'
                    type='checkbox' />
                  <label className='table-footer__label table-footer__label--checkbox' htmlFor='RoleMaintenance_chkFilter'>Show expired</label>
                </div>) : null }
              </div>
            </div>
          </section>
        </Page>
        { modal }
      </div>
    );
  }
}

export default LicenseAssignment;



// WEBPACK FOOTER //
// ./src/components/Admin/LicenseAssignment.js